import React from 'react';
import { StateProvider } from './providers/stateManager';
import ModalBody from './ui/ModalBody';
import { stateKeys } from './constants/stateKeys';
import { EventsProvider } from './providers/events';
import Modal from './ui/Modal';
import { createOpenModal } from './hocs/createOpenModal';
import CommentCard from './ui/CommentCard';

const defaultState = {
  [stateKeys.files]: [],
  [stateKeys.images]: [],
  [stateKeys.text]: '',
  [stateKeys.visible]: false,
};

const CommentsModalTemplate = ({
  children,
  initialState,
  getCommentAttachment,
  onEditComment,
  onAddComment,
  onDeleteComment,
  getWorkerName,
}) => {
  return (
    <StateProvider initialState={{ ...defaultState, ...initialState }}>
      <EventsProvider
        onAddComment={onAddComment}
        onEditComment={onEditComment}
        onDeleteComment={onDeleteComment}
        getCommentAttachment={getCommentAttachment}
        getWorkerName={getWorkerName}
      >
        {children}
      </EventsProvider>
    </StateProvider>
  );
};

CommentsModalTemplate.Modal = Modal;
CommentsModalTemplate.ModalBody = ModalBody;

CommentsModalTemplate.extend = (Component) => {
  Component.CommentCard = CommentCard;
  Component.createOpenModal = createOpenModal;
  return Component;
};

export default CommentsModalTemplate;
